import {
  Button,
  Menu,
  MenuItem,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Stack,
  CircularProgress,
} from '@mui/material';
import HelpOutline from '@mui/icons-material/HelpOutline';
import { useState, MouseEvent } from 'react';
import { Link } from '@vs-online-only-app/ui';
import { useGetAssociateSettings } from '@vs-online-only-app/state';

const HelpMenu = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [isSupportModalOpen, setIsSupportModalOpen] = useState<boolean>(false);

  const { data, isLoading } = useGetAssociateSettings();

  const handleClick = (e: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(e.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSupportOpen = () => {
    setIsSupportModalOpen(true);
    handleClose();
  };

  return (
    <Stack>
      <Button
        onClick={handleClick}
        startIcon={<HelpOutline />}
        variant="contained"
        color="secondary"
        disableElevation
      >
        Help
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        sx={{ mt: 1 }}
      >
        <MenuItem onClick={handleSupportOpen}>Get support</MenuItem>
        <Link
          to={data?.onboarding.faqURL || ''}
          target="_blank"
          underline="none"
        >
          <MenuItem disabled={isLoading}>
            {isLoading ? <CircularProgress size={16} /> : 'FAQ'}
          </MenuItem>
        </Link>
      </Menu>
      <Dialog
        open={isSupportModalOpen}
        onClose={() => setIsSupportModalOpen(false)}
      >
        <DialogTitle>Get support</DialogTitle>
        <DialogContent dividers>
          <Stack gap={2}>
            <DialogContentText>
              Please contact us through the following email:
              <br />
              <Link to="mailto:support-chat@bambuser.com">
                support-chat@bambuser.com
              </Link>
            </DialogContentText>
            <DialogContentText>
              When contacting support, please also ensure you provide a clear
              description of any issues or queries being raised, along with any
              supporting evidence.
            </DialogContentText>
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setIsSupportModalOpen(false)}>OK</Button>
        </DialogActions>
      </Dialog>
    </Stack>
  );
};

export default HelpMenu;
